/* Rebelle · Atelier — progressive enhancement (no dependencies).
   - Adds .rebelle-atelier to <body> so the skin activates.
   - .rb-motion only when motion is allowed (reveal animations).
   - .rb-scrolled on <body> after the page leaves the top (header state).
   - IntersectionObserver reveals product cards with a per-item stagger.
   Fails safe: if anything throws, everything stays fully visible/usable. */
(function () {
  var root = document.body;
  if (!root) return;
  root.classList.add('rebelle-atelier');

  /* Header scrolled state — cheap, passive, rAF-throttled. */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('rb-scrolled', window.scrollY > 24);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  root.classList.add('rb-motion');

  function wire() {
    var cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;

    cards.forEach(function (card, i) {
      card.style.setProperty('--rb-i', (i % 8).toString());
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rb-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    cards.forEach(function (card) { io.observe(card); });
  }

  if (document.readyState !== 'loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);

  /* Re-wire after Horizon section re-renders (filters, pagination, etc.). */
  document.addEventListener('shopify:section:load', wire);
})();
